import axios from 'axios';
import resolve  from '../resolver.js';
import checkJwt from '../../Global/jwtChecker';
import logout from '../../Global/logout';

export default async function DeleteProviderCountry(   
   uuid
) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }
    
    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/country/'+ uuid, {
            method: 'delete',
            headers: { 'Authorization' : unHashedJwt}           
        }).then(res => res)
        .catch(error => error.response.data)
    );
}